import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import firebase from "firebase/compat/app";
import Cloudinary from "cloudinary-vue";
import "vue-wysiwyg/dist/vueWysiwyg.css";
import wysiwyg from "vue-wysiwyg";

Vue.use(wysiwyg, {
  hideModules: {
    image: true,
    table: true,
  },
});

Vue.config.productionTip = false;

Vue.use(Cloudinary, {
  configuration: {
    cloudName: "inoverus",
  },
});

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyADt1PSuT56FE8CmEi8jW09B0f-gh7R16Y",
  authDomain: "kamrankhalidwebsite.firebaseapp.com",
  projectId: "kamrankhalidwebsite",
  storageBucket: "kamrankhalidwebsite.appspot.com",
  messagingSenderId: "840918454997",
  appId: "1:840918454997:web:8f36c4e8c5645c5028085c",
  measurementId: "G-4R45QEH2B1"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

let app;

firebase.auth().onAuthStateChanged((user) => {
  console.log("user", user);
  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      render: (h) => h(App),
    }).$mount("#app");
  }
});

// new Vue({
//   router,
//   store,
//   vuetify,
//   render: h => h(App)
// }).$mount('#app')
